<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part-title" id="pt-1"><a id="page_1">I. Definitions</a></h1><a id="page_1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008_Part01.vue?300928db